function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "\u260DQronoport / Foundation / icons / search");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.5
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Components-/-Search-/-Bar",
  transform: "translate(-343.000000, -14.000000)",
  fill: "#06273A"
}, React.createElement("g", {
  id: "Group-7"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-icons-/-search",
  transform: "translate(340.000000, 11.500000)"
}, React.createElement("path", {
  d: "M21.6741751,20.0692381 L17.7580443,16.0891905 C17.730002,16.0606905 17.6979536,16.0389762 17.6672406,16.0140952 C19.9391128,12.7994762 19.6618055,8.29919048 16.8184044,5.40938095 C15.2377974,3.80297619 13.1662274,3 11.0946574,3 C9.02308747,3 6.95151749,3.80297619 5.3709105,5.40938095 C2.2096965,8.62219048 2.2096965,13.8309048 5.3709105,17.0437143 C6.95151749,18.650119 9.02308747,19.4530952 11.0946574,19.4530952 C12.8866945,19.4530952 14.6769512,18.8491667 16.1511755,17.6471905 C16.1627485,17.6603095 16.1716508,17.6752381 16.184114,17.6879048 L20.1002448,21.6679524 C20.3174614,21.889619 20.6023357,22 20.8872099,22 C21.1720842,22 21.4569585,21.889619 21.6741751,21.6688571 C22.1086083,21.226881 22.1086083,20.5107619 21.6741751,20.0692381 Z M11.0946574,17.1916429 C9.5269588,17.1916429 8.05317965,16.5709762 6.94439564,15.4445476 C4.65605416,13.1188571 4.65605416,9.33469048 6.94439564,7.009 C8.05273454,5.88257143 9.5269588,5.26190476 11.0946574,5.26190476 C12.6623561,5.26190476 14.1361352,5.88257143 15.2449192,7.009 C17.5332607,9.33469048 17.5332607,13.1188571 15.2449192,15.4445476 C14.1361352,16.5709762 12.6623561,17.1916429 11.0946574,17.1916429 Z",
  id: "Shape"
})))));

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "19px",
    height: "20px",
    viewBox: "0 0 19 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.246f2115.svg";
export { ForwardRef as ReactComponent };